"use strict";
exports.__esModule = true;
exports.Image = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var __1 = require("../");
function Image(props) {
    var theme = __1.useTheme();
    var image = props.image, alt = props.alt, caption = props.caption, _a = props.captionPosition, captionPosition = _a === void 0 ? 'under' : _a;
    return typeof image === 'string' ? (captionPosition === 'overflow' ? (react_1["default"].createElement(__1.Box, { alignItems: "center", display: "flex", position: "relative" },
        react_1["default"].createElement("img", { alt: alt, src: image, style: { width: '100%', height: 'auto' } }),
        caption && (react_1["default"].createElement(__1.Box, { bgcolor: theme.palette.primary.main + 'aa', color: "primary.contrastText", position: "absolute", style: {
                width: '100%',
                padding: 10,
                bottom: 0,
                right: 0,
                zIndex: 10
            }, textAlign: "center" }, caption)))) : (react_1["default"].createElement(__1.StackSpacing, { alignItems: "stretch", scale: 3 },
        react_1["default"].createElement("img", { alt: alt, src: image, style: { width: '100%', height: 'auto' } }),
        react_1["default"].createElement(__1.BodyText, null, caption)))) : (react_1["default"].createElement(react_1["default"].Fragment, null, image));
}
exports.Image = Image;
//# sourceMappingURL=Image.js.map